import React from 'react';
import { portfolioData } from '../mockData';
import ArrowIcon from './ArrowIcon';

const Experience = () => {
  const { experience } = portfolioData;

  return (
    <section id="experience">
      <div className="label reveal">Experience</div>
      <div className="entry-list">
        {experience.map((job) => (
          <div className="entry reveal" key={`${job.company}-${job.duration}`}>
            <span className="badge">{job.duration}</span>
            <div className="entry-header">
              {job.partnerLogo ? (
                <div className="logo-stack" title={`${job.partner} consultant at ${job.company}`}>
                  <span
                    className="logo-stack-partner"
                    role="img"
                    aria-label={`${job.partner} logo`}
                    style={{ backgroundImage: `url(${job.partnerLogo})` }}
                  />
                  <img src={job.logo} alt={`${job.company} logo`} className="logo-stack-main" />
                </div>
              ) : (
                <img src={job.logo} alt={`${job.company} logo`} className="entry-logo" />
              )}
              <div>
                <div className="entry-title">{job.company}</div>
                <div className="entry-location">{job.location}</div>
              </div>
            </div>
            <div className="entry-sub">{job.description}</div>
            {job.sections?.map((section) => (
              <div className="entry-section" key={section.heading}>
                <div className="entry-section-heading">{section.heading}</div>
                <ul className="entry-bullets">
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
            <span className="arrow-link">
              {job.title} <ArrowIcon />
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
